import { render, staticRenderFns } from "./form-partial-professional-kitchen.vue?vue&type=template&id=4c9ab1c5"
import script from "./form-partial-professional-kitchen.vue?vue&type=script&lang=js"
export * from "./form-partial-professional-kitchen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports